var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "intersecting-circles-spinner", style: _vm.spinnerStyle },
    [
      _c(
        "div",
        { staticClass: "spinnerBlock", style: _vm.spinnerBlockStyle },
        _vm._l(_vm.circleStyles, function(cs, index) {
          return _c("span", { key: index, staticClass: "circle", style: cs })
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }